import type { AdminUatData, UatItem } from '../types'

/**
 * TEST DATA for the local UAT tab preview (Summit State, a fictional
 * customer). Nothing here is a real customer item, case, person or Linear
 * issue. The preview pages show a "Test Data" alert with it.
 */
export const UAT_PREVIEW_ITEMS: UatItem[] = [
  {
    id: '6f3c1d2e-0000-4000-8000-000000000001',
    title: 'Job Board Saved Filters',
    description: 'Students can save a set of Job Board filters and open it again from the sidebar. Test data for local review.',
    linearIdentifier: 'P-9001',
    deliveredOn: '2026-10-28',
    status: 'in_testing',
    updatedAt: '2026-11-02T15:10:00.000Z',
    cases: [
      { id: '6f3c1d2e-0000-4000-8000-0000000000a1', text: 'Save a filter set with location and job type, then reload the page.', area: 'Job Board', result: 'pass', note: null, resultBy: 'Test Tester', resultAt: '2026-11-02T14:40:00.000Z' },
      { id: '6f3c1d2e-0000-4000-8000-0000000000a2', text: 'Rename a saved filter set from the sidebar.', area: 'Job Board', result: 'fail', note: 'The new name shows only after a page reload.', resultBy: 'Test Tester', resultAt: '2026-11-02T15:05:00.000Z' },
      { id: '6f3c1d2e-0000-4000-8000-0000000000a3', text: 'Delete a saved filter set and confirm it is gone on another device.', area: 'Job Board', result: 'not_run', note: null, resultBy: null, resultAt: null },
      { id: '6f3c1d2e-0000-4000-8000-0000000000a4', text: 'Open a saved filter set on a 375px phone screen.\nExpected: The filters fit without a sideways scroll.', area: 'Mobile', result: 'not_run', note: null, resultBy: null, resultAt: null },
    ],
    history: [
      { id: '6f3c1d2e-0000-4000-8000-0000000000b1', kind: 'status', authorName: 'Prentus', authorSide: 'prentus', body: null, fromValue: null, toValue: 'delivered', caseText: null, createdAt: '2026-10-28T13:00:00.000Z' },
      { id: '6f3c1d2e-0000-4000-8000-0000000000b2', kind: 'status', authorName: 'Test Tester', authorSide: 'customer', body: null, fromValue: 'delivered', toValue: 'in_testing', caseText: null, createdAt: '2026-11-02T14:30:00.000Z' },
      { id: '6f3c1d2e-0000-4000-8000-0000000000b3', kind: 'case_result', authorName: 'Test Tester', authorSide: 'customer', body: null, fromValue: 'not_run', toValue: 'pass', caseText: 'Save a filter set with location and job type, then reload the page.', createdAt: '2026-11-02T14:40:00.000Z' },
      { id: '6f3c1d2e-0000-4000-8000-0000000000b4', kind: 'case_result', authorName: 'Test Tester', authorSide: 'customer', body: 'The new name shows only after a page reload.', fromValue: 'not_run', toValue: 'fail', caseText: 'Rename a saved filter set from the sidebar.', createdAt: '2026-11-02T15:05:00.000Z' },
    ],
  },
  {
    id: '6f3c1d2e-0000-4000-8000-000000000002',
    title: 'Advisor Review Queue Sorting',
    description: 'Advisors can sort the review queue by submission date or by program. Test data for local review.',
    linearIdentifier: 'P-9002',
    deliveredOn: '2026-10-21',
    status: 'passed',
    updatedAt: '2026-10-30T18:00:00.000Z',
    cases: [
      { id: '6f3c1d2e-0000-4000-8000-0000000000c1', text: 'Sort the queue by submission date, newest first.', area: 'Advisor Tools', result: 'pass', note: null, resultBy: 'Test Tester', resultAt: '2026-10-30T17:40:00.000Z' },
      { id: '6f3c1d2e-0000-4000-8000-0000000000c2', text: 'Sort the queue by program name.', area: 'Advisor Tools', result: 'pass', note: null, resultBy: 'Test Tester', resultAt: '2026-10-30T17:45:00.000Z' },
    ],
    history: [
      { id: '6f3c1d2e-0000-4000-8000-0000000000d1', kind: 'status', authorName: 'Prentus', authorSide: 'prentus', body: null, fromValue: null, toValue: 'delivered', caseText: null, createdAt: '2026-10-21T13:00:00.000Z' },
      { id: '6f3c1d2e-0000-4000-8000-0000000000d2', kind: 'note', authorName: 'Test Tester', authorSide: 'customer', body: 'Sorting works on both campuses. Ready to pass.', fromValue: null, toValue: null, caseText: null, createdAt: '2026-10-30T17:55:00.000Z' },
      { id: '6f3c1d2e-0000-4000-8000-0000000000d3', kind: 'status', authorName: 'Test Tester', authorSide: 'customer', body: null, fromValue: 'in_testing', toValue: 'passed', caseText: null, createdAt: '2026-10-30T18:00:00.000Z' },
    ],
  },
  {
    id: '6f3c1d2e-0000-4000-8000-000000000003',
    title: 'Resume Review Email Reminders',
    description: 'Students get one email when a resume review is waiting for more than three days. Test data for local review.',
    linearIdentifier: null,
    deliveredOn: '2026-10-24',
    status: 'needs_fix',
    updatedAt: '2026-10-29T16:20:00.000Z',
    cases: [
      { id: '6f3c1d2e-0000-4000-8000-0000000000e1', text: 'Leave a resume review open for three days and check the inbox.', area: 'Notifications', result: 'fail', note: 'Two reminder emails arrived on day three.', resultBy: 'Test Tester', resultAt: '2026-10-29T16:15:00.000Z' },
    ],
    history: [
      { id: '6f3c1d2e-0000-4000-8000-0000000000f1', kind: 'status', authorName: 'Prentus', authorSide: 'prentus', body: null, fromValue: null, toValue: 'delivered', caseText: null, createdAt: '2026-10-24T13:00:00.000Z' },
      { id: '6f3c1d2e-0000-4000-8000-0000000000f2', kind: 'status', authorName: 'Test Tester', authorSide: 'customer', body: 'Students got two reminders instead of one.', fromValue: 'in_testing', toValue: 'needs_fix', caseText: null, createdAt: '2026-10-29T16:20:00.000Z' },
    ],
  },
  {
    id: '6f3c1d2e-0000-4000-8000-000000000004',
    title: 'Career Fair Check-In Page',
    description: 'Employers check students in at a career fair with a QR code. Test data for local review.',
    linearIdentifier: 'P-9004',
    deliveredOn: '2026-11-03',
    status: 'delivered',
    updatedAt: '2026-11-03T13:00:00.000Z',
    cases: [],
    history: [
      { id: '6f3c1d2e-0000-4000-8000-000000000101', kind: 'status', authorName: 'Prentus', authorSide: 'prentus', body: null, fromValue: null, toValue: 'delivered', caseText: null, createdAt: '2026-11-03T13:00:00.000Z' },
    ],
  },
]

/** TEST DATA for the local admin UAT editor preview. */
export function uatPreviewAdminData(): AdminUatData {
  return {
    items: UAT_PREVIEW_ITEMS.map(({ history: _history, ...item }, position) => ({
      ...item,
      key: null,
      linearIssueUrl: item.linearIdentifier ? `https://linear.app/prentus/issue/${item.linearIdentifier}` : null,
      position,
      updatedBy: 'test-data@prentus.com',
    })),
    events: UAT_PREVIEW_ITEMS.flatMap((item) => item.history.map((entry) => ({
      ...entry,
      itemId: item.id,
      itemTitle: item.title,
      authorEmail: entry.authorSide === 'prentus' ? 'test-data@prentus.com' : 'tester@example.edu',
      syncStatus: entry.authorSide === 'customer' && (entry.kind === 'note' || entry.toValue === 'needs_fix' || entry.toValue === 'fail') ? 'pending' as const : 'none' as const,
      syncError: null,
      linearIssueIdentifier: null,
      linearIssueUrl: null,
      slackNotifiedAt: null,
    }))),
    linearKeyConfigured: false,
    routing: { labelCount: 0, customerLinked: false, titlePrefix: null, source: 'none' },
  }
}
